module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_02-490355ad2c498139fd00600519997c5d.png";